export const sessionStorageHelper = {
    getIsSigningOut: () =>(sessionStorage.getItem('isSigningOut') === null ? false : sessionStorage.getItem('isSigningOut')),
    setIsSigningOut: (bool) => sessionStorage.setItem('isSigningOut', bool)
};